export const COLORS = {
  home: {
    lightBg: "#f3e095",
    darkBg: "#1b2124",
    lightFont: "white",
    darkFont: "white",
    lightButtonBgHover: "#1b212440",
    darkButtonBgHover: "#f3e09540",
    pinkBg: "#F3E2F4",
  },
  timeline: {
    lightBg: "#9cbade",
    darkBg: "#1b2124",
  },
  footer: {
    lightBg: "#89E1A0",
    darkBg: "#233922",
  },
  navbar: {
    darkFont: "white",
    lightFont: "white",
    darkSelectedFont: "#f3e095",
    lightSelectedFont: "#C3B789",
  },
  projects: {
    greenBg: "#E1F0DA",
    darkGreenBg: "#BEDFAE",
  },
};
const SIZES = [];
